<div class="user-delegation-form">

	<div class="modal-header">
		<div class="row align-items-center">
			<h2 class="modal-title" translate="InactivityPeriod.Title"></h2>
			<i class="ml-2 far fa-info-circle" ngbTooltip="{{ 'InactivityPeriod.ForPeriodTooltip' | translate }}"></i>
		</div>
		<button type="button" class="modal-button-close far fa-times" (click)="cancel.emit()"></button>
	</div>

	<div [formGroup]="form" class="modal-body" [class.block-loader]="loader.isLoading$ | async">
		<loader-spinner [model]="loader"/>

		<div class="user-delegation-form-clients col-12 mb-4">
			<div class="row">
				<div class="col-1 pt-2" translate="InactivityPeriod.PeriodFrom"></div>
				<div class="col-5">
					<form-datepicker
						formControlName="start"
						[forcePropagation]="startField.dirty"
						[control]="startField"
						[minDate]="today"
						inputClass="form-control-alt"
						[class.is-invalid]="startField.dirty && startField.invalid"
						placement="top"
					/>
					<form-control-feedback [field]="startField"/>
				</div>

				<div class="col-1 pt-2" translate="InactivityPeriod.PeriodUntil"></div>
				<div class="col-5">
					<form-datepicker
						formControlName="end"
						[forcePropagation]="endField.dirty"
						[control]="endField"
						[minDate]="today"
						inputClass="form-control-alt"
						[class.is-invalid]="endField.dirty && endField.invalid"
						placement="top"
					/>
					<form-control-feedback [field]="endField" [messages]="{rangeInconsistency: 'Forms.FieldErrorMessages.AfterStartDate'}"/>
				</div>
			</div>
		</div>

		@if (mode !== ActionType.CREATE) {
			<div class="row align-items-center">
				<div class="pl-4 col-10">
					<input type="checkbox" formControlName="setActive" (change)="reactivate($any($event.currentTarget))" />
					<label class="ml-3" translate="InactivityPeriod.Reactivate"></label>
					<form-control-feedback [field]="setActiveField"/>
				</div>
			</div>
		}
	</div>

	<div class="modal-footer d-flex flex-row-reverse">
		<button type="button" class="btn btn-primary"
				(click)="onSubmit()"
				[disabled]="form.invalid"
				translate="Actions.SaveAlt" data-cy="SaveAlt"></button>

		<button type="button" class="btn btn-default"
				(click)="cancel.emit()"
				translate="Actions.Cancel" data-cy="Cancel"></button>
	</div>
</div>
